export enum ModeBtnViews {
    RAPID,
    GUIDED
}